import script from "./mark-passed-button.vue?vue&type=script&lang=js"
export * from "./mark-passed-button.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__